import { CarFront, ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollToId } from "../config/business";

export const UsedCar = () => (
  <section id="used-car" className="bg-[#0b0c0e] pb-24 lg:pb-32">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal>
        <div className="flex flex-col items-start gap-6 border border-[#00AEEF]/30 bg-[#141519] p-8 lg:flex-row lg:items-center lg:p-10">
          <div className="flex h-14 w-14 shrink-0 items-center justify-center border border-[#00AEEF]/40 bg-[#00AEEF]/10">
            <CarFront className="h-7 w-7 text-[#00AEEF]" strokeWidth={1.7} />
          </div>
          <div className="flex-1">
            <h2 className="font-display text-2xl font-bold uppercase tracking-tight text-[#f4f4f2] sm:text-3xl">
              Buying a Used Car?
            </h2>
            <p className="mt-2 max-w-3xl leading-relaxed text-[#a6a9b1]">
              Get a better understanding of the vehicle before you buy — ask us
              about a <strong className="text-[#e6e7ea]">Pre-Purchase Vehicle Inspection</strong>.
              Recently purchased? Post-purchase inspections are also available to
              establish your vehicle's current mechanical condition and
              maintenance needs.
            </p>
          </div>
          <button
            data-testid="used-car-inspection-button"
            onClick={() => scrollToId("appointment")}
            className="btn-ghost shrink-0 !text-sm"
          >
            Ask About an Inspection
            <ArrowRight className="h-4 w-4 text-[#00AEEF]" />
          </button>
        </div>
      </Reveal>
    </div>
  </section>
);
